import React from 'react'
import './project.css'

function Project() {

   const projects=[
     {
      title:"E-Mall",
      id:1,
      src:"/assets/mall.png",
      link:'https://e-mall-mahdi.netlify.app',
      technologies:["Angular","Node.js", "Epxress.js", "MySql"],
      description:"Engineered and deployment E-Mall is an e-commerce app dedicated to smartphones."
      },{
      title:"GYM-app",
      id:3,
      src:"/assets/gym.png",
      link:'https://gym-mahdi.vercel.app',
      technologies:["React.js","Node.js", "Epxress.js", "MongoDB"],
      description:"Developed and deployment Gym-app used (MERN) where users can sign up and subscribe online."
      },
      {title:"Movie-app",
        id:2,
      src:"/assets/movie.png",
      link:'https://movies-mahdi.netlify.app',
      technologies:["Next.js 14","server component,MongoDB"],
      description:"Developed movie app used Full stack Next.js 14 applied server component for SEO."
      },
    {
    title:"E-commerce",
    id:1,
    src:"/assets/e-commerce.png",
    link:'https://e-commerce-mahdi.vercel.app',
    technologies:["React.js","Node.js", "Epxress.js", "MongoDB"],
    description:"Engineered and implemented an innovative E-commerce app used (MERN) for computer and smartphone companies."
    },
   { title:"Education planning-app",
        src:"/assets/angular.png",
        id:4,
        link:'https://github.com/Mahdialaya5/Education-planning-App',
        technologies:["Angular","Node.js", "Express.js", "MongoDB"],
        description:"I developed Education planning-app (MEAN) where the planning of guilds , students and instructors"
        }
  ]

  return (
    <>
    <p className='title_project'  >MY PROJECT</p>
    <div id='projects'  className='project' >
 { projects.map((el)=> <div className="card" key={el.id} >
  <div className="card-header">
    <img src={el.src} alt="Project" className="card-img"/>
  </div>
  <div className="card-body">
    <h2 className="card-title">{el.title}</h2>
    <p className="card-description">{el.description}</p>
    <div className="card-tags">
     {el.technologies.map((e,i)=><span key={i}  className="tag">{e}</span>) }
 </div>
    <a href={el.link}  target='_blank' rel="noreferrer"  className="card-btn">View Project</a>
  </div>
</div>)}
    </div>
    </>
  )
}

export default Project